var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "413FAB34-880A-49F0-A159-BEDD560413FC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,20 C1.790861,20 0,18.209139 0,16 L0,4 C0,1.790861 1.790861,0 4,0 L16,0 C18.209139,0 20,1.790861 20,4 L20,20 L4,20 Z M16,1 L4,1 C2.34314575,1 1,2.34314575 1,4 L1,16 C1,17.6568542 2.34314575,19 4,19 L16,19 L16,16 L19,16 L19,4 C19,2.40231912 17.75108,1.09633912 16.1762728,1.00509269 L16,1 Z M19,17 L17,17 L17,19 L19,19 L19,17 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "5 5 5 7 6 7 6 5 9.5 5 9.5 14 8.5 14 8.5 15 9.5 15 10.5 15 11.5 15 11.5 14 10.5 14 10.5 5 14 5 14 7 15 7 15 5 15 4 5 4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBlock);
export default __webpack_public_path__ + "static/media/TextBlock.020f3626686618f645a3ac236234244c.svg";
export { ForwardRef as ReactComponent };